import { useEffect, useState, Fragment, useRef } from 'react';
import { Col } from "reactstrap";
import './../index.scss'
import { getLenderSessionUrl, getUserDetail, updateUserState } from '../../../api/onboarding';
import IframeResizer from 'iframe-resizer-react'
import CircularProgress from '@material-ui/core/CircularProgress';
import { setToLocalStorage, getFromLocalStorage } from '../../../utils/Helpers';

const AcceptOffer = (props) => {
    const [loading, setLoading] = useState(false);
    const [session, setSession] = useState({});

    const onboardRef = useRef(null)

    useEffect(() => {
      fetchSession()
    },[]);

    useEffect(() => {
      window.addEventListener('message', (event) => {
        if(event.data.detail?.applicationStatus === "COMPLETED"){
          let userState = "LOAN_APPLICATION_COMPLETED"
          let userData = getFromLocalStorage('userData');

          updateUserState(userState, userData.userId).then(response => {
            setToLocalStorage('token', {step: 'dashboard'});
            setTimeout(() => {
              props.history.replace({pathname: '/dashboard', search: props?.location?.search});
            }, 5000);
          })
        }
      })
      return (
        window.removeEventListener('message', this)
      )
    },[])

    const fetchSession = () => {
      setLoading(true);
      getLenderSessionUrl().then(res => {
        setLoading(false);
        setSession(res)
      })
    }

    if (loading) {
      return <Fragment>
        <div className="loading">
          <CircularProgress />
        </div>
      </Fragment>
    }

    return (
      <Fragment>
        <div className="acceptOfferContainer">
          <Col md={12}>
            <IframeResizer ref={onboardRef} heightCalculationMethod="lowestElement" maxWidth="600" scrolling="true" src={session?.url} allow="camera; geolocation" />
          </Col>
        </div>
      </Fragment>
    )
}

export default AcceptOffer;
